import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsUpdateRequest } from "../services/index";

const API_URL = "/api/hr/config";

// Fetch HrConfig
export const fetchHrConfig = createAsyncThunk("hrConfig/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await hrmsGetRequest(API_URL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch HR config");
  }
});

// Update HrConfig
export const updateHrConfig = createAsyncThunk("hrConfig/update", async (configData, { rejectWithValue }) => {
  try {
    const response = await hrmsUpdateRequest(API_URL, configData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to update HR config");
  }
});

const hrConfigSlice = createSlice({
  name: "hrConfig",
  initialState: {
    hrConfig: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHrConfig.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHrConfig.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.hrConfig = action.payload;
        state.error = null;
      })
      .addCase(fetchHrConfig.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateHrConfig.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateHrConfig.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.hrConfig = action.payload;
        state.error = null;
      })
      .addCase(updateHrConfig.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default hrConfigSlice.reducer;